import { Box, BoxProps, styled } from '@mui/material';

export const TopBarContainer = styled(Box)<BoxProps>(({ theme }) => ({
  background: 'linear-gradient(264.6deg, #30893C 39.72%, #6DBD78 134.15%)',
  padding: '8px 16px',
}));
